import "./App.scss";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// Component Imports
import Main from "./pages/Main";
import Kiosk from "./pages/Kiosk";

function App() {
	return (
		<Router>
			<Routes>
				<Route path='/' element={<Kiosk />}></Route>
				{/* <Route path='/kiosk' element={<Kiosk />}></Route> */}
			</Routes>
		</Router>
	);
}

export default App;
